import styled from "styled-components";

export const Container = styled.div`
  .income-report-uploader > div.ant-upload.ant-upload-select.ant-upload-select-text {
    border: 1px solid var(--ant-primary-color);
    border-radius: 1.5rem;
  }
  .income-report-uploader {
    height: auto;
    display: block;
    margin: 1rem 0 1.5rem 0;
    
    .ant-upload {
      width: 100%;
      height: 120px;
      margin-top: 4px;

      .upload-text-icon {
        height: 100%;
        cursor: pointer;
        font-size: 20px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        svg {
          fill: var(--ant-primary-color);
        }

        .upload-text-desc {
          font-size: 14px;
          text-align: center;
        }
      }

      .loading-container {
        height: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        .anticon {
          width: 40px;
          height: 40px;
          margin-bottom: 12px;

          svg {
            width: 100%;
            height: 100%;
            fill: var(--ant-primary-color);
          }
        }
      }
    }
  }
`;
